// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:768px){.entry-meta[data-v-1532cbfd]{border-top:none}}.entry-meta[data-v-1532cbfd]{display:flex;align-items:center}.entry-meta a[data-v-1532cbfd]{margin:0 .5rem}.entry-meta a[data-v-1532cbfd]:last-child{margin:0 0 0 .5rem}.entry-meta svg[data-v-1532cbfd]{margin:0 .5rem}@media screen and (min-width:768px){.entry-meta[data-v-1532cbfd]{justify-content:flex-end}}", ""]);
// Exports
module.exports = exports;
